import { jsx as _jsx } from "react/jsx-runtime";
import SharedComponents from "../SharedComponents";
const VariantPicker = (props) => {
    let { renderProductVariantPicker } = SharedComponents.useContext();
    if (typeof renderProductVariantPicker === "function") {
        return renderProductVariantPicker(props);
    }
    return (_jsx("div", { children: "variant picker not implemented" }));
};
export default VariantPicker;
